// import React from "react";
// import {
//   DataTable,
//   TableContainer,
//   Table,
//   TableHead,
//   TableRow,
//   TableExpandHeader,
//   TableHeader,
//   TableBody,
//   TableExpandRow,
//   TableCell,
//   TableExpandedRow,
//   StructuredListWrapper,
//   StructuredListHead,
//   StructuredListCell,
//   StructuredListRow,
//   StructuredListBody,
// } from "@carbon/react";

export const View = (props) => {
  return (
    <div className="no-data-card flex-container justify-content--center align-item--center">
      <div>{props.errorMessage}</div>
    </div>
  );
};
